var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      enableBackground: "new"
    },
    d: "M19.928,17.579c0.053,0.278,0.516,0.952,0.713,1.185 c0.508,0.604,1.027,0.969,0.832,1.318c-0.269,0.409-1.806-0.109-2.557-0.414c-0.379-0.157-1.477-0.659-1.889-1.062 c-0.651,0.121-1.338,0.188-2.043,0.188c-2.145,0-4.092-0.6-5.536-1.578c0.428,0.049,0.865,0.073,1.309,0.073 c5.116,0,9.265-3.341,9.265-7.459c0-0.485-0.059-0.959-0.168-1.418c1.938,1.055,3.189,2.725,3.189,4.604 C23.044,14.87,21.823,16.521,19.928,17.579z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.786,16.114c-0.754,0-1.485-0.068-2.183-0.199c-0.439,0.433-1.614,0.969-2.017,1.137c-0.8,0.323-2.444,0.878-2.729,0.442 c-0.211-0.375,0.344-0.766,0.888-1.409c0.211-0.248,0.705-0.969,0.762-1.267c-2.025-1.131-3.329-2.896-3.329-4.877 c0-3.41,3.854-6.174,8.608-6.174c4.753,0,8.608,2.764,8.608,6.174C18.395,13.352,14.539,16.114,9.786,16.114z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/ic_chat.c93efce44388992f851a231f842797e0.svg";
export { ForwardRef as ReactComponent };